import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./styles.module.css";

export default function SwiperWrapper({ children, variant = "primary", className, ...rest }) {
  const rootClass = classNames({
    [styles.root]: true,
    [styles[variant]]: variant,
    className,
  });
  return <div className={rootClass}>{children}</div>;
}

SwiperWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary", "quaternary"]),
};
